import React from 'react';
import KycDetail from '../components/KYC/Detail';

export default function KycDetailPage() {
	return <KycDetail />;
}
